import { render } from "./Thema.vue?vue&type=template&id=76653540"
import script from "./Thema.vue?vue&type=script&lang=js"
export * from "./Thema.vue?vue&type=script&lang=js"
script.render = render

export default script